(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nordglow-bundle-tiers"] && !Shopify.designMode) return;
  try {
    (function () {
    var tiers = document.querySelector('[data-ng-tiers]');
    if (!tiers) return;
    var pills = Array.prototype.slice.call(tiers.querySelectorAll('[data-ng-tier-value]'));
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var value = pill.getAttribute('data-ng-tier-value');
        var setInputs = document.querySelectorAll('[data-ng-set]');
        setInputs.forEach(function (input) {
          if (input.value === value) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        });
        pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
      });
    });
    function markActive() {
      var checked = document.querySelector('[data-ng-set]:checked');
      pills.forEach(function (p) { p.classList.toggle('is-active', checked && p.getAttribute('data-ng-tier-value') === checked.value); });
    }
    document.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-ng-set')) markActive(); });
    markActive();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nordglow-exit-intent"] && !Shopify.designMode) return;
  try {
    (function () {
    var wrap = document.querySelector('[data-ng-exit]');
    if (!wrap) return;
    var KEY = 'ng_exit_shown';
    if (sessionStorage.getItem(KEY)) return;

    var dialog = wrap.querySelector('[data-ng-exit-dialog]');
    var body = wrap.querySelector('[data-ng-exit-body]');
    var success = wrap.querySelector('[data-ng-exit-success]');
    var form = wrap.querySelector('[data-ng-exit-form]');
    var shown = false;
    var isTouch = window.matchMedia('(hover: none)').matches;

    function open() {
      if (shown) return;
      shown = true;
      sessionStorage.setItem(KEY, '1');
      wrap.hidden = false;
      dialog.showModal ? dialog.showModal() : (dialog.setAttribute('open', ''));
      requestAnimationFrame(function () { wrap.classList.add('is-open'); });
      var email = wrap.querySelector('[data-ng-exit-email]');
      if (email) setTimeout(function () { email.focus(); }, 260);
    }
    function close() {
      wrap.classList.remove('is-open');
      setTimeout(function () {
        if (dialog.close) dialog.close(); else dialog.removeAttribute('open');
        wrap.hidden = true;
      }, 240);
    }

    wrap.querySelectorAll('[data-ng-exit-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        var email = wrap.querySelector('[data-ng-exit-email]');
        if (!email || !email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { e.preventDefault(); return; }
      });
      form.addEventListener('submit', function () {
        setTimeout(function () {
          if (body) body.hidden = true;
          if (success) success.hidden = false;
        }, 400);
      });
    }

    setTimeout(function () {
      if (shown) return;
      if (!isTouch) {
        document.addEventListener('mouseout', function (e) {
          if (e.clientY <= 0 && e.relatedTarget == null) open();
        }, { once: true });
      } else {
        var lastY = window.scrollY, peak = 0;
        window.addEventListener('scroll', function () {
          var y = window.scrollY;
          if (y > peak) peak = y;
          if (peak > 600 && lastY - y > 120) open();
          lastY = y;
        }, { passive: true });
      }
    }, parseInt(wrap.dataset.ngExitDelay || '8000', 10));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nordglow-sticky-atc"] && !Shopify.designMode) return;
  try {
    class NgStickyAtc extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-ng-sticky-bar]');
      this.btn = this.querySelector('[data-ng-sticky-btn]');
      this.priceEl = this.querySelector('[data-ng-sticky-price]');
      this.form = document.querySelector('[data-ng-form]');
      if (!this.bar || !this.btn || !this.form) return;

      this.btn.addEventListener('click', () => {
        const submit = this.form.querySelector('[data-ng-cta], button[type="submit"]');
        if (submit && !submit.disabled) submit.click();
      });

      this.form.addEventListener('change', () => this.syncPrice());
      this.syncPrice();

      const sentinel = this.form;
      const footer = document.querySelector('footer') || document.querySelector('.ng-closing');
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.target === sentinel) {
            const past = !e.isIntersecting && e.boundingClientRect.top < 0;
            this.atFooter ? null : this.toggle(past);
          } else if (e.target === footer) {
            this.atFooter = e.isIntersecting;
            if (e.isIntersecting) this.toggle(false);
            else this.toggle(this.form.getBoundingClientRect().top < 0);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      this.io.observe(sentinel);
      if (footer) this.io.observe(footer);
    }

    syncPrice() {
      const idInput = this.form.querySelector('[data-ng-variant], input[name="id"]');
      if (!idInput || !this.priceEl) return;
      const dataEl = this.form.closest('#ng-' + this.dataset.productId?.replace?.(/\D/g,'') ) ;
      const json = document.querySelector('[data-ng-variant-data]');
      if (!json) return;
      try {
        const variants = JSON.parse(json.textContent);
        const v = variants.find((x) => String(x.id) === String(idInput.value));
        if (v) {
          this.priceEl.textContent = v.price;
          this.btn.disabled = !v.available;
        }
      } catch (e) {}
    }

    toggle(show) {
      this.hidden = false;
      this.classList.toggle('is-visible', !!show);
    }

    disconnectedCallback() { this.io && this.io.disconnect(); }
  }
  if (!customElements.get('sticky-add-to-cart-ng')) {
    customElements.define('sticky-add-to-cart-ng', NgStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
